// extracted by mini-css-extract-plugin
export default {"Form":"VJRU-zlDB2_w_7vEa2L2u","columns":"_1XZUZd2JpUAy0WNlRzWTYL","bad":"_3geBsThUPCvkwt-kioczia"};